window.BlockContent = () => {
    return {

    }
}


// WEBPACK FOOTER //
// ./scripts/blocks/Content.js